// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"189":"4ff7e818","230":"0ddfcdd1","254":"2ee10b29","265":"15dbdd49","272":"f1cc3167","392":"7748858a","445":"0660c292","554":"0038e9f8","679":"87386d81","787":"0904c1f0","822":"03db0975","918":"d2648ada"}[chunkId] + ".chunk.js";
};